import { getAppConfig } from '@/utils/config';
import { Message } from '@/models/Message';
import { MessageBubble } from '@/components/chat/MessageBubble';
import { MessageContent } from '@/components/chat/MessageContent';
import { MessageSteps } from '@/components/chat/MessageSteps';
import { PermissionsContext } from '@/components/context/PermissionsContext';
import { UserIcon } from '@/components/chat/UserIcon';

import { Fragment, useContext } from 'react';
import { styled } from '@mui/material';

type MessageListProps = {
  messages: Message[];
  className?: string;
};

const MessageList = ({ messages, ...rest }: MessageListProps) => {
  const { isReadOnly } = useContext(PermissionsContext);
  const shouldShowSteps = getAppConfig((_) => _.conversation.show_steps, false);

  return (
    <Wrapper {...rest}>
      {messages.map((message) => (
        <Fragment key={message.id}>
          <LayoutMessage>
            <MessageBubble
              icon={<UserIcon message={message} />}
              content={<MessageContent message={message} />}
            />
          </LayoutMessage>
          {/* hide step progress on share page */}
          {shouldShowSteps && !isReadOnly && (
            <LayoutSteps>
              <MessageSteps message={message} />
            </LayoutSteps>
          )}
        </Fragment>
      ))}
    </Wrapper>
  );
};

export default MessageList;

const Wrapper = styled('div')`
  color: #ffffff;
`;

const LayoutMessage = styled('div')`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

const LayoutSteps = styled('div')`
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  &:empty {
    display: none;
  }
`;
